import { gql } from '@zenbusiness/application-commons-graphql';

export const ENTITY_SELECTOR_QUERY = gql`
  query BusinessEntitySelector($limit: Int!) {
    businessEntitySelector(limit: $limit) {
      businessEntities {
        name
        uuid
        hasNameReservation
      }
    }
  }
`;
